export default "__VITE_ASSET__DwDPKXet__"